import React from 'react';
import "./ToggleSwitch.css"

// `disabled` is optional so existing feis/grade call sites are untouched.
const ToggleSwitch = ({ checked, onChange, disabled = false }) => {

    return (
        <label className="toggle-switch" style={disabled ? { opacity: 0.45, cursor: "not-allowed" } : undefined}>
            <input
                type="checkbox"
                checked={checked}
                onChange={disabled ? undefined : onChange}
                disabled={disabled}
            />
            <span className="slider" />
        </label>
    );
};

export default ToggleSwitch;